import { Component, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { MenuService } from '../theme/components/menu/menu.service';
import { MatDialog } from '@angular/material/dialog';
import { MenuData } from '../theme/components/menu/menu';
import { Menu } from '../theme/components/menu/menu.model';
import { SubscriptionsContainer } from '../theme/utils/subscriptions-container';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    providers: [MenuService],
    standalone: false
})
export class PagesComponent implements OnInit {

  @ViewChild('backToTop') backToTop: any;
  @ViewChild('mainContent') mainContent: ElementRef;

  public settings: Settings;
  public sidenavOpen: boolean = true;
  public pageTitle: string = '';
  public showSidenav: boolean = false;
  public showInfoContent: boolean = false;
  public toggleSearchBar: boolean = false;
  private defaultMenu: string;
  public menus = ['vertical', 'horizontal'];
  public menuOption: string;
  public menuTypes = [
    { label: 'Padrão',    value: 'default'  },
    { label: 'Compacto',  value: 'compact'  }
  ];
  public menuTypeOption: string;
  subs = new SubscriptionsContainer();
  isHomolog: boolean = environment.isHomolog;
  showLayoutSettings: boolean = environment.showLayoutSettings;

  constructor(public appSettings: AppSettings, public router: Router, private menuService: MenuService,
              private dialog: MatDialog) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    if (window.innerWidth <= 960) {
      this.settings.menu = 'vertical';
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
      this.sidenavOpen = false;
    }
    this.menuOption = this.settings.menu;
    this.menuTypeOption = this.settings.menuType;
    this.defaultMenu = this.settings.menu;
    this.updatePageTitle(this.router.url);
  }

  ngAfterViewInit() {
    setTimeout(() => { this.settings.loadingSpinner = false; }, 300);
    this.backToTop.nativeElement.style.display = 'none';
    this.subs.add = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
        this.updatePageTitle(event.urlAfterRedirects || event.url);
        this.limparBloqueioDeRolagemOrfao();
      }
      if (window.innerWidth <= 960) {
        this.sidenavOpen = false;
      }
    });

    // Rede de seguranca para o bloqueio de rolagem do CDK (ver metodo abaixo).
    this.subs.add = this.dialog.afterAllClosed.subscribe(() => {
      // Espera o CDK terminar de desmontar o overlay antes de conferir.
      setTimeout(() => this.limparBloqueioDeRolagemOrfao());
    });

    if (this.settings.menu === 'vertical') {
      this.menuService.expandActiveSubMenu(this.menuService.getMenu());
    }
  }

  /**
   * Enquanto um overlay do CDK esta aberto (todo MatDialog usa a estrategia
   * `block` por padrao, e o seletor de aplicacoes a usa explicitamente), o CDK
   * poe `cdk-global-scrollblock` no <html>:
   *
   *   .cdk-global-scrollblock { position: fixed; width: 100%; overflow-y: scroll }
   *
   * e guarda a posicao da rolagem em style.top/left para restaurar no fechamento.
   * Se o overlay for destruido sem passar pelo caminho normal de fechamento -
   * uma excecao durante o close, ou o componente sendo destruido junto com uma
   * navegacao - a classe fica orfa e a pagina inteira para de rolar, em qualquer
   * dispositivo, ate dar reload. Como depende de o fechamento falhar, o efeito e
   * intermitente.
   *
   * Aqui so removemos o bloqueio quando ele esta aplicado E nao ha nenhum overlay
   * aberto, entao um bloqueio legitimo nunca e desfeito.
   */
  private limparBloqueioDeRolagemOrfao(): void {
    const html = document.documentElement;
    if (!html.classList.contains('cdk-global-scrollblock')) {
      return;
    }
    if (document.querySelector('.cdk-overlay-pane')) {
      return; // ainda ha overlay aberto: o bloqueio e legitimo
    }

    // O CDK guarda a posicao anterior como offset negativo em top/left.
    const topAnterior = parseInt(html.style.top || '0', 10) || 0;
    const leftAnterior = parseInt(html.style.left || '0', 10) || 0;

    html.classList.remove('cdk-global-scrollblock');
    html.style.top = '';
    html.style.left = '';
    window.scroll(-leftAnterior, -topAnterior);
  }

  ngOnDestroy() {
    this.subs.dispose();
  }

  public toggleSidenav() {
    this.sidenavOpen = !this.sidenavOpen;
  }

  // Título da página exibido na topbar — derivado do MenuData pela rota atual
  private updatePageTitle(url: string) {
    const path = (url || '/').split('?')[0];
    let best: Menu | null = null;
    let bestLen = -1;
    for (const menu of MenuData) {
      if (!menu.routerLink) { continue; }
      const link = menu.routerLink;
      const match = (link === '/')
        ? path === '/'
        : (path === link || path.startsWith(link + '/'));
      if (match && link.length > bestLen) {
        best = menu;
        bestLen = link.length;
      }
    }
    if (!best && path === '/') {
      this.pageTitle = 'Página Inicial';
      return;
    }
    this.pageTitle = best ? best.title : '';
  }

  public chooseMenuType() {
    this.settings.menuType = this.menuTypeOption;
  }

  public changeTheme(theme: string) {
    this.settings.theme = theme;
  }

  public closeInfoContent(showInfoContent: boolean) {
    this.showInfoContent = !showInfoContent;
  }

  @HostListener('window:resize') onWindowResize(): void {
    if (window.innerWidth <= 960) {
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
      this.settings.menu = 'vertical';
      this.sidenavOpen = false;
    } else {
      this.settings.menu = (this.defaultMenu === 'horizontal') ? 'horizontal' : 'vertical';
      this.settings.sidenavIsOpened = true;
      this.settings.sidenavIsPinned = true;
      this.sidenavOpen = true;
    }
  }

  public scrollToTop() {
    if (this.mainContent?.nativeElement) {
      this.mainContent.nativeElement.scrollTo({ behavior: 'smooth', top: 0 });
    } else {
      window.scrollTo({ behavior: 'smooth', top: 0 });
    }
  }

  public closeSubMenus() {
    if (this.settings.menu === 'vertical') {
      this.menuService.closeAllSubMenus();
    }
  }

  onMainContentScroll(event: any) {
    this.toggleBackToTop(event.target.scrollTop);
  }

  @HostListener('window:scroll') onWindowScroll(): void {
    this.toggleBackToTop(window.scrollY);
  }

  toggleBackToTop(value: number) {
    if (this.backToTop?.nativeElement) {
      this.backToTop.nativeElement.style.display = value > 300 ? 'flex' : 'none';
    }
  }
}
